/* ============================================================
   DIER & PLEZIER - global.js  (vanilla JS, geen libraries)
   ============================================================ */
(function () {
  'use strict';

  var DP = window.DP || {};
  var S = DP.strings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Mobiel menu ---------- */
  function initMobileMenu() {
    var nav = $('#MobileNav');
    if (!nav) return;
    var toggles = $all('[data-menu-toggle]');

    function zet(open) {
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () { zet(!nav.classList.contains('is-open')); });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) zet(false);
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) zet(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) zet(false);
    });

    var subToggles = $all('[data-submenu-toggle]', nav);
    subToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        subToggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var s = b.nextElementSibling;
          if (s) s.classList.remove('is-open');
        });
        if (!wasOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var sub = btn.nextElementSibling;
          if (sub) sub.classList.add('is-open');
        }
      });
    });
  }

  /* ---------- Winkelwagen ---------- */
  var Cart = {
    drawer: null,
    laatstGeopendDoor: null,

    open: function (trigger) {
      if (!this.drawer) return;
      this.laatstGeopendDoor = trigger || document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var sluit = $('[data-cart-close]', this.drawer);
      if (sluit && sluit.focus) sluit.focus();
    },

    close: function () {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.laatstGeopendDoor && this.laatstGeopendDoor.focus) this.laatstGeopendDoor.focus();
    },

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      $all('[data-cart-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(b); });
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) self.close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
      this.ververs(false);
    },

    add: function (id, quantity) {
      var self = this;
      return fetch(DP.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Toevoegen mislukt'); });
          return r.json();
        })
        .then(function () { return self.ververs(true); });
    },

    change: function (key, quantity) {
      var self = this;
      return fetch(DP.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.teken(cart); });
    },

    ververs: function (openen) {
      var self = this;
      return fetch(DP.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.teken(cart);
          if (openen) self.open();
        });
    },

    teken: function (cart) {
      this.telling(cart.item_count);
      this.verzendbalk(cart.total_price);

      var body = $('[data-cart-body]');
      var foot = $('[data-cart-foot]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + escapeHtml(S.empty || 'Je winkelwagen is leeg.') + '</p>' +
          '<a href="' + (DP.allProductsUrl || '/collections/all') + '" class="btn btn--primary">' +
          escapeHtml(S.keepShopping || 'Verder winkelen') + '</a></div>';
        if (foot) foot.hidden = true;
        return;
      }

      var html = '<ul class="cart-items" data-cart-items>';
      cart.items.forEach(function (item) {
        var foto = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
        html += '<li class="cart-item" data-cart-item data-key="' + escapeHtml(item.key) + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="cart-item__media">' +
          (foto ? '<img src="' + escapeHtml(foto) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
          '<div class="cart-item__info">' +
          '<a href="' + escapeHtml(item.url) + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
          (item.variant_title ? '<span class="cart-item__variant">' + escapeHtml(item.variant_title) + '</span>' : '') +
          '<div class="cart-item__qty">' +
          '<button type="button" class="qty-btn" data-qty-down aria-label="Minder">&minus;</button>' +
          '<span data-qty>' + item.quantity + '</span>' +
          '<button type="button" class="qty-btn" data-qty-up aria-label="Meer">&plus;</button></div></div>' +
          '<div class="cart-item__end"><span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="cart-item__remove" data-cart-remove>' + escapeHtml(S.remove || 'Verwijder') + '</button>' +
          '</div></li>';
      });
      html += '</ul>';
      body.innerHTML = html;

      if (foot) {
        foot.hidden = false;
        var totaal = $('[data-cart-subtotal]', foot);
        if (totaal) totaal.textContent = formatMoney(cart.total_price);

        /* Voordeelregel. total_discount is wat de automatische stapelkorting
           er daadwerkelijk af haalt, dus deze regel liegt nooit: staat de
           korting niet aan in Shopify, dan blijft hij verborgen. */
        var voordeel = $('[data-cart-saving]', foot);
        if (voordeel) {
          var korting = cart.total_discount || 0;
          voordeel.hidden = korting <= 0;
          var bedrag = $('[data-cart-saving-amount]', voordeel);
          if (bedrag) bedrag.textContent = '− ' + formatMoney(korting);
        }
      }
    },

    telling: function (count) {
      $all('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      $all('[data-cart-toggle]').forEach(function (b) {
        b.setAttribute('aria-label', 'Winkelwagen (' + count + ')');
      });
    },

    verzendbalk: function (total) {
      var el = $('[data-shipbar]');
      if (!el) return;
      var drempel = DP.freeShippingThreshold || 9995;
      var rest = Math.max(0, drempel - total);
      var pct = Math.min(100, Math.round((total / drempel) * 100));
      var tekst;
      if (rest === 0) {
        tekst = '<p class="shipbar__text">🎉 <strong>' +
          escapeHtml(S.freeShippingUnlocked || 'Je hebt gratis verzending!') + '</strong></p>';
      } else {
        tekst = '<p class="shipbar__text">Nog <strong>' + formatMoney(rest) + '</strong> tot gratis verzending</p>';
      }
      el.innerHTML = tekst + '<div class="shipbar__track"><div class="shipbar__fill" style="width:' + pct + '%"></div></div>';
    }
  };

  document.addEventListener('click', function (e) {
    var itemEl = e.target.closest('[data-cart-item]');
    if (!itemEl) return;
    var key = itemEl.getAttribute('data-key');
    var qtyEl = $('[data-qty]', itemEl);
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-qty-up]')) Cart.change(key, qty + 1);
    else if (e.target.closest('[data-qty-down]')) Cart.change(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-cart-remove]')) Cart.change(key, 0);
  });

  /* ---------- Toevoegen aan winkelwagen ---------- */
  function initAddToCart() {
    $all('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var btn = form.querySelector('[type="submit"]');
        if (!idInput) return;
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        Cart.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
          .catch(function (err) { alert(err.message || 'Er ging iets mis. Probeer het opnieuw.'); })
          .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
      });
    });
  }

  /* ---------- Andere producten ----------
     De sectie toont al producten uit dezelfde collectie. Heeft Shopify echte
     aanbevelingen, dan vervangen we die lijst. Vervangen dus, niet toevoegen,
     anders staan de producten er dubbel.                                     */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el) return;
    var url = el.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nieuw = doc.querySelector('.card-grid');
        if (!nieuw || nieuw.children.length === 0) return;

        var huidig = el.querySelector('.card-grid');
        if (huidig) huidig.replaceWith(nieuw);
        else el.appendChild(nieuw);
        el.hidden = false;
      })
      .catch(function () { /* stil laten; de collectielijst blijft dan staan */ });
  }

  /* ---------- Collectie: filters, sorteren, meer laden ---------- */
  function initCollection() {
    var fToggle = $('[data-filter-toggle]');
    var filters = $('[data-filters]');
    if (fToggle && filters) {
      fToggle.addEventListener('click', function () {
        var open = filters.classList.toggle('is-open');
        fToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) filters.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    function bouwUrl(form, sortValue) {
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (waarde, sleutel) {
          if (waarde !== null && String(waarde).trim() !== '') params.append(sleutel, waarde);
        });
      }
      if (sortValue) params.set('sort_by', sortValue);
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    var facetForm = $('#FacetForm');
    var sortSel = $('[data-sort]');

    if (facetForm) {
      facetForm.addEventListener('change', function () {
        window.location = bouwUrl(facetForm, sortSel ? sortSel.value : null);
      });
      facetForm.addEventListener('submit', function (e) {
        e.preventDefault();
        window.location = bouwUrl(facetForm, sortSel ? sortSel.value : null);
      });
    }

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        window.location = bouwUrl(facetForm, sortSel.value);
      });
    }

    var grid = $('[data-product-grid]');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn || !grid) return;
      e.preventDefault();
      var url = btn.getAttribute('href');
      var origineel = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Laden…';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nieuwe = doc.querySelectorAll('[data-product-grid] .product-card');
          nieuwe.forEach(function (c) { grid.appendChild(c); });
          var wrap = btn.closest('.collection__loadmore');
          var volgende = doc.querySelector('[data-load-more]');
          if (volgende && wrap) { wrap.innerHTML = ''; wrap.appendChild(volgende); }
          else if (wrap) { wrap.remove(); }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = origineel;
        });
    });
  }

  /* ---------- Productpagina ---------- */
  function initProduct() {
    var form = $('[data-product-form][data-type="add-to-cart"]');
    if (!form) return;

    var variantInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-quantity]', form);
    if (!variantInput) return;

    var variants = [];
    try { variants = JSON.parse(variantInput.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }

    function huidigeVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantInput.value)) return variants[i];
      }
      return variants[0] || null;
    }

    var start = huidigeVariant();
    var state = { stukprijs: start ? start.price : 0, aantal: 1, korting: 0 };

    var gallery = $('[data-gallery]');
    if (gallery) {
      $all('[data-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-index');
          $all('[data-slide]', gallery).forEach(function (s) {
            s.classList.toggle('is-active', s.getAttribute('data-index') === idx);
          });
          $all('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    }

    function berekenBundel(aantal, korting) {
      var totaal = state.stukprijs * aantal;
      return Math.round(totaal - (totaal * korting / 100));
    }

    /* Alle bundelregels opnieuw uitrekenen. Nodig zodra de bezoeker een andere
       variant kiest: 10 kg mag niet de prijzen van 2 kg blijven tonen.
       Drie dingen per regel: de doorgestreepte oude prijs, de nieuwe prijs en
       de per-stuk-regel met het kortingspercentage. */
    function updateBundelRegels() {
      $all('[data-bundle-option]').forEach(function (opt) {
        var aantal = parseInt(opt.getAttribute('data-qty'), 10) || 1;
        var korting = parseInt(opt.getAttribute('data-discount'), 10) || 0;
        var vol = state.stukprijs * aantal;
        var eind = berekenBundel(aantal, korting);

        var wasEl = opt.querySelector('[data-bundle-was]');
        if (wasEl) {
          if (korting > 0) {
            wasEl.textContent = formatMoney(vol);
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        var prijsEl = opt.querySelector('[data-bundle-price]');
        if (prijsEl) prijsEl.textContent = formatMoney(eind);

        var perEl = opt.querySelector('[data-bundle-perunit]');
        if (perEl) {
          if (aantal > 1) {
            perEl.textContent = formatMoney(Math.round(eind / aantal)) + ' per stuk';
            perEl.hidden = false;
          } else {
            perEl.textContent = '';
            perEl.hidden = true;
          }
        }

        var offEl = opt.querySelector('[data-bundle-off]');
        if (offEl) {
          offEl.textContent = '−' + korting + '%';
          offEl.hidden = korting === 0;
        }

        var saveEl = opt.querySelector('[data-bundle-save]');
        if (saveEl) {
          var saveText = saveEl.querySelector('[data-bundle-save-text]');
          if (saveText) saveText.textContent = 'Je bespaart ' + formatMoney(vol - eind);
          saveEl.hidden = korting === 0;
        }
      });
    }

    /* De grote prijs bovenaan volgt de gekozen bundel. Bij korting komt het
       volle bedrag doorgestreept ernaast met wat je bespaart. De gewone
       variantkorting (compare_at_price) gaat dan even uit: twee doorgestreepte
       prijzen naast elkaar leest niemand meer. */
    function updatePrijzen() {
      var prijsEl = $('[data-price]');
      var stickyEl = $('[data-sticky-price]');
      var vol = state.stukprijs * state.aantal;
      var waarde = (state.aantal === 1 && state.korting === 0)
        ? state.stukprijs
        : berekenBundel(state.aantal, state.korting);
      var voordeel = vol - waarde;

      if (prijsEl) {
        prijsEl.textContent = formatMoney(waarde);
        prijsEl.classList.toggle('price--sale', voordeel > 0);
      }
      if (stickyEl) stickyEl.textContent = formatMoney(waarde);
      if (qtyInput) qtyInput.value = state.aantal;

      var variant = huidigeVariant();
      var opAanbieding = !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);

      var bundelCompare = $('[data-bundle-compare]');
      var bundelSaving = $('[data-bundle-saving]');
      if (bundelCompare) {
        bundelCompare.textContent = formatMoney(vol);
        bundelCompare.hidden = voordeel <= 0;
      }
      if (bundelSaving) {
        bundelSaving.textContent = 'Je bespaart ' + formatMoney(voordeel) + ' (−' + state.korting + '%)';
        bundelSaving.hidden = voordeel <= 0;
      }

      var compareEl = $('[data-compare]');
      var savingEl = $('[data-saving]');
      if (compareEl) compareEl.hidden = voordeel > 0 || !opAanbieding;
      if (savingEl) savingEl.hidden = voordeel > 0 || !opAanbieding;

      var stickyCompare = $('[data-sticky-compare]');
      if (stickyCompare) {
        if (voordeel > 0) {
          stickyCompare.textContent = formatMoney(vol);
          stickyCompare.hidden = false;
        } else if (opAanbieding) {
          stickyCompare.textContent = formatMoney(variant.compare_at_price);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }

      updateBundelRegels();
    }

    $all('[data-bundle-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        $all('[data-bundle-option]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var input = opt.querySelector('input');
        if (input) input.checked = true;
        state.aantal = parseInt(opt.getAttribute('data-qty'), 10) || 1;
        state.korting = parseInt(opt.getAttribute('data-discount'), 10) || 0;
        updatePrijzen();
      });
    });

    function gekozenOpties() {
      var opts = [];
      $all('[data-option-input]:checked').forEach(function (i) {
        opts[parseInt(i.getAttribute('data-option-position'), 10) - 1] = i.value;
      });
      return opts;
    }

    $all('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var name = input.getAttribute('name');
        $all('input[name="' + name + '"]').forEach(function (i) {
          if (i.parentElement) i.parentElement.classList.toggle('is-selected', i.checked);
        });
        var sel = gekozenOpties();
        var match = variants.filter(function (v) {
          return v.options.every(function (o, idx) { return o === sel[idx]; });
        })[0];
        if (!match) return;

        variantInput.value = match.id;
        state.stukprijs = match.price;

        var buyBtn = $('[data-buy-btn]');
        var stickyBtn = $('[data-sticky-buy-btn]');
        [buyBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !match.available; });
        var label = $('[data-buy-label]');
        if (label) label.textContent = match.available ? (S.addToCart || 'In winkelwagen') : (S.soldOut || 'Uitverkocht');

        /* Tekst van de variantkorting bijwerken. Of hij zichtbaar is bepaalt
           updatePrijzen hieronder, want bij een bundel gaat hij uit. */
        var compareEl = $('[data-compare]');
        var savingEl = $('[data-saving]');
        var heeftAanbieding = !!(match.compare_at_price && match.compare_at_price > match.price);
        if (compareEl && heeftAanbieding) compareEl.textContent = formatMoney(match.compare_at_price);
        if (savingEl && heeftAanbieding) savingEl.textContent = 'Bespaar ' + formatMoney(match.compare_at_price - match.price);

        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', u.toString());
        }
        updatePrijzen();
      });
    });

    var buyBtn = $('[data-buy-btn]');
    var stickyBar = $('[data-sticky-buy]');
    if (buyBtn && stickyBar && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-buy');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          stickyBar.classList.toggle('is-visible', !e.isIntersecting);
          stickyBar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '0px 0px -20% 0px' });
      io.observe(buyBtn);
    }
    var stickyBtn = $('[data-sticky-buy-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    updatePrijzen();
  }

  /* ---------- Accordeon (FAQ en productinformatie) ---------- */
  function initAccordion() {
    $all('[data-accordion] [data-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = btn.nextElementSibling;
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* ---------- Verzendinformatie ---------- */
  function initDeliveryCountdown() {
    var el = $('[data-delivery-countdown]');
    if (!el) return;
    var textEl = $('[data-dc-text]', el);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 17;
    var dmin = parseInt(el.getAttribute('data-min'), 10) || 2;
    var dmax = parseInt(el.getAttribute('data-max'), 10) || 5;
    var carrier = DP.carrier || 'DHL';
    var levertijd = ' Levertijd ' + dmin + '–' + dmax + ' werkdagen.';

    function truckSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
    }

    function render() {
      var now = new Date();
      var dag = now.getDay();
      var h = now.getHours(), m = now.getMinutes();
      var werkdag = dag >= 1 && dag <= 5;
      var voorCutoff = h < cutoff;
      var msg;

      if (werkdag && voorCutoff) {
        var minuten = (cutoff - h) * 60 - m;
        var uu = Math.floor(minuten / 60), mm = minuten % 60;
        var t = uu > 0 ? (uu + 'u ' + mm + 'm') : (mm + 'm');
        msg = 'Bestel binnen <b>' + t + '</b>, dan gaat je pakket <b>vandaag</b> nog weg.' + levertijd;
      } else if (werkdag && dag < 5) {
        msg = 'Na ' + cutoff + ':00 besteld? Je pakket gaat <b>morgen</b> weg via ' + carrier + '.' + levertijd;
      } else {
        msg = 'Je pakket gaat <b>maandag</b> weg via ' + carrier + '.' + levertijd;
      }

      if (textEl) textEl.innerHTML = truckSvg() + ' ' + msg;
    }

    render();
    setInterval(render, 30000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    Cart.init();
    initAddToCart();
    initRecommendations();
    initCollection();
    initProduct();
    initAccordion();
    initDeliveryCountdown();
  });

  window.DP_Cart = Cart;
})();
